/* Facefitness: Pfeile für die Bewertungs-Fotoleiste (Judge.me) */
(function(){
  var SEL='#judgeme_product_reviews .jm-expanded-media-grid__container';
  function init(c){
    if(c.getAttribute('data-ff-strip')) return; c.setAttribute('data-ff-strip','1');
    var host=c.parentElement; if(!host) return;
    var nav=document.createElement('div'); nav.className='ff-strip-nav';
    nav.innerHTML='<button type="button" class="ff-strip-btn" data-d="-1" aria-label="Vorherige Fotos">&larr;</button><button type="button" class="ff-strip-btn" data-d="1" aria-label="Weitere Fotos">&rarr;</button>';
    host.appendChild(nav);
    var prev=nav.children[0], next=nav.children[1];
    function upd(){ prev.disabled=c.scrollLeft<8; next.disabled=c.scrollLeft+c.clientWidth>=c.scrollWidth-8; }
    nav.addEventListener('click',function(e){var b=e.target.closest('button'); if(!b) return; c.scrollBy({left:(+b.getAttribute('data-d'))*c.clientWidth*0.75,behavior:'smooth'});});
    c.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); setTimeout(upd,300); upd();
  }
  var q=false;
  function scan(){ q=false; var l=document.querySelectorAll(SEL); for(var i=0;i<l.length;i++) init(l[i]); }
  new MutationObserver(function(){ if(!q){ q=true; requestAnimationFrame(scan); } }).observe(document,{childList:true,subtree:true});
  document.addEventListener('DOMContentLoaded',scan);
})();

/* Facefitness: "Seite X von Y" unter der Bewertungs-Navigation */
(function(){
  function upd(){
    var nav=document.querySelector('#judgeme_product_reviews .jm-pagination-controls'); if(!nav) return;
    var max=0,cur=1; nav.querySelectorAll('.jm-pagination-controls__button--page').forEach(function(b){var n=parseInt(b.textContent,10); if(n>max) max=n; if(b.getAttribute('aria-current')==='page') cur=n;});
    var lab=nav.nextElementSibling; if(!lab||!lab.classList.contains('ff-pag-label')){ lab=document.createElement('p'); lab.className='ff-pag-label'; nav.parentNode.insertBefore(lab,nav.nextSibling); }
    var t='Seite <b>'+cur+'</b> von <b>'+max+'</b>'; if(max>1 && lab.innerHTML!==t) lab.innerHTML=t; lab.style.display=max>1?'':'none';
  }
  var q=false;
  new MutationObserver(function(){ if(!q){ q=true; requestAnimationFrame(function(){ q=false; upd(); }); } }).observe(document,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-current']});
})();

/* Facefitness: Gutschein-Betrag per Regler + Schnellwahl (bedient die normale Variantenauswahl) */
(function(){
  var QUICK=[60,100,200,300,500];
  function radios(){ var vp=document.querySelector('variant-picker'); return vp?Array.prototype.slice.call(vp.querySelectorAll('input[type=radio]')):[]; }
  function num(r){ return parseInt(String(r.value).replace(/\./g,'').split(',')[0].replace(/[^0-9]/g,''),10)||0; }
  function eur(n){ return n.toLocaleString('de-DE')+' €'; }
  function pick(r){ if(!r||r.checked) return; var l=document.querySelector('label[for="'+r.id+'"]'); if(l) l.click(); else { r.checked=true; r.dispatchEvent(new Event('change',{bubbles:true})); } }
  function paint(root,rs,i){
    var s=root.querySelector('[data-ffv-slider]'); var max=Math.max(rs.length-1,1);
    s.max=rs.length-1; s.value=i; s.style.setProperty('--p',(i/max*100)+'%');
    s.setAttribute('aria-valuetext',eur(num(rs[i])));
    var a=document.querySelector('[data-ffv-amount]'); var t=eur(num(rs[i]));
    if(a && a.textContent!==t){ a.textContent=t; a.classList.remove('is-bump'); void a.offsetWidth; a.classList.add('is-bump'); }
    root.querySelectorAll('.ffv__q').forEach(function(b){ b.setAttribute('aria-pressed', +b.getAttribute('data-v')===num(rs[i]) ? 'true':'false'); });
  }
  function init(){
    var root=document.querySelector('[data-ffv]'); if(!root) return; var rs=radios(); if(!rs.length) return;
    var s=root.querySelector('[data-ffv-slider]');
    if(!root.getAttribute('data-ready')){
      root.setAttribute('data-ready','1');
      var q=root.querySelector('[data-ffv-quick]');
      rs.forEach(function(r){ var n=num(r); if(QUICK.indexOf(n)>-1){ var b=document.createElement('button'); b.type='button'; b.className='ffv__q'; b.setAttribute('data-v',n); b.textContent=eur(n); q.appendChild(b); } });
      q.addEventListener('click',function(e){ var b=e.target.closest('.ffv__q'); if(!b) return; var list=radios(); for(var k=0;k<list.length;k++){ if(num(list[k])===+b.getAttribute('data-v')){ paint(root,list,k); pick(list[k]); break; } } });
      s.addEventListener('input',function(){ root._drag=true; paint(root,radios(),+s.value); });
      s.addEventListener('change',function(){ root._drag=false; var list=radios(); pick(list[+s.value]); });
    }
    if(root._drag) return;
    var i=0; for(var k=0;k<rs.length;k++){ if(rs[k].checked){ i=k; break; } }
    paint(root,rs,i);
  }
  var q=false;
  new MutationObserver(function(){ if(!q){ q=true; requestAnimationFrame(function(){ q=false; init(); }); } }).observe(document,{childList:true,subtree:true});
  document.addEventListener('change',function(e){ if(e.target.closest && e.target.closest('variant-picker')) setTimeout(init,0); });
  document.addEventListener('DOMContentLoaded',init);
})();

/* Facefitness: Chips (Pills) immer in einer Reihe – Schrift schrumpft, bis alles passt */
(function(){
  function fit(){
    document.querySelectorAll('.ffp-tagwrap .ffp-tags').forEach(function(r){
      var t=r.querySelectorAll('.ffp-tag'); if(!t.length) return;
      t.forEach(function(x){ x.style.fontSize=''; });
      var s=parseFloat(getComputedStyle(t[0]).fontSize);
      while(r.scrollWidth>r.clientWidth+1 && s>8.5){ s-=0.25; t.forEach(function(x){ x.style.fontSize=s+'px'; }); }
    });
  }
  var q; function later(){ clearTimeout(q); q=setTimeout(fit,60); }
  if(document.readyState!=='loading') fit(); else document.addEventListener('DOMContentLoaded',fit);
  window.addEventListener('load',fit); window.addEventListener('resize',later);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fit);
})();


/* Facefitness: Alle Text-Pfeile (→ ←) werden zu runden Linienpfeilen im Kreis */
(function(){
  var P='<path d="M5 12h14M13 6l6 6-6 6"/>';
  var SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'+P+'</svg>';
  var RE=/[→←]/;
  function circ(el){
    if(/(__go|__ar|__arr|strip-btn|pag__nav)\b/.test(el.className||'')) return true;
    var w=el.offsetWidth,h=el.offsetHeight; if(!w||!h) return false;
    var r=parseFloat(getComputedStyle(el).borderTopLeftRadius)||0;
    return Math.abs(w-h)<4 && r>=w/2-2 && w>=18;
  }
  function mk(left,tight){var s=document.createElement('span');s.className='ffx'+(left?' ffx--l':'')+(tight?' ffx--tight':'');s.setAttribute('aria-hidden','true');s.innerHTML=SVG;return s;}
  function fix(t){
    var p=t.parentElement; if(!p||p.closest('script,style,textarea,input,select,[contenteditable],.ffx,.ffx-in,#judgeme_product_reviews .jm-review-item')) return;
    if(!p.closest('a,button,[role=button],.ffx-ok')) return;
    var v=t.nodeValue, m=v.match(RE); if(!m) return;
    var left=m[0]==='←', rest=v.replace(RE,'');
    if(!rest.trim() && p.childNodes.length===1 && p.tagName!=='A' && p.tagName!=='BUTTON'){
      if(circ(p)){ p.classList.add('ffx-in'); if(left) p.classList.add('ffx--l'); p.innerHTML=SVG; }
      else { var cs=getComputedStyle(p.parentElement); var tight=/flex|grid/.test(cs.display)&&parseFloat(cs.columnGap)>0; var pos=getComputedStyle(p).position; p.classList.add('ffx'); if(left) p.classList.add('ffx--l'); if(tight||pos==='absolute'||pos==='fixed') p.classList.add('ffx--tight'); p.setAttribute('aria-hidden','true'); p.innerHTML=SVG; }
      return;
    }
    if(!rest.trim() && p.childNodes.length===1 && circ(p)){ p.classList.add('ffx-in'); if(left) p.classList.add('ffx--l'); p.innerHTML=SVG; return; }
    var parts=v.split(RE); var f=document.createDocumentFragment();
    if(parts[0]) f.appendChild(document.createTextNode(parts[0].replace(/\s+$/,'')+(parts[0].trim()?'':'')));
    var cs2=getComputedStyle(p); var tight2=/flex|grid/.test(cs2.display)&&parseFloat(cs2.columnGap)>0;
    f.appendChild(mk(left,tight2||!parts[0].trim()));
    if(parts[1]&&parts[1].trim()) f.appendChild(document.createTextNode(' '+parts[1].replace(/^\s+/,'')));
    t.replaceWith(f);
  }
  function swapIcons(root){
    var l=root.querySelectorAll('svg.icon-chevron-left:not(.ffx-swap),svg.icon-chevron-right:not(.ffx-swap)');
    for(var i=0;i<l.length;i++){var s=l[i]; if(!s.closest('button.button,.flickity-button')) continue; s.classList.add('ffx-swap'); s.setAttribute('viewBox','0 0 24 24'); s.innerHTML=P; if(s.classList.contains('icon-chevron-left')) s.style.transform='scaleX(-1)';}
  }
  function scan(){
    q=false; var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,{acceptNode:function(n){return RE.test(n.nodeValue)?1:3;}}),n,list=[];
    while(n=w.nextNode()) list.push(n);
    for(var i=0;i<list.length;i++){ try{fix(list[i]);}catch(e){} }
    swapIcons(document);
    var hs=[],xs=document.querySelectorAll('.ffx,.ffx-in');
    for(var k=0;k<xs.length;k++){var e=xs[k].parentElement,host=xs[k].closest('a,button');while(e&&host&&host.contains(e)){if(!e.hasAttribute('data-ffl'))hs.push(e);if(e===host)break;e=e.parentElement;}}
    for(var j=0;j<hs.length;j++){var h=hs[j];h.setAttribute('data-ffl','1');try{var c=getComputedStyle(h),af=getComputedStyle(h,'::after'),bf=getComputedStyle(h,'::before');
      if(parseFloat(c.borderBottomWidth)>0&&parseFloat(c.borderTopWidth)===0) h.classList.add('ffx-nob');
      if(af.content!=='none'&&parseFloat(af.height)<=3) h.classList.add('ffx-noa');
      if(bf.content!=='none'&&parseFloat(bf.height)<=3) h.classList.add('ffx-nobf');
    }catch(e){}}
  }
  var q=false;
  new MutationObserver(function(){ if(!q){ q=true; requestAnimationFrame(scan); } }).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState!=='loading') scan(); else document.addEventListener('DOMContentLoaded',scan);
})();


/* Facefitness: einheitliche Button-Texte */
(function(){
  var MAP=[[/In den Einkaufswagen legen/g,'In den Warenkorb']];
  function run(){var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,{acceptNode:function(n){return /Einkaufswagen/.test(n.nodeValue)?1:3;}}),n,l=[];while(n=w.nextNode())l.push(n);
    l.forEach(function(t){var v=t.nodeValue;MAP.forEach(function(m){v=v.replace(m[0],m[1]);});if(v!==t.nodeValue)t.nodeValue=v;});
    document.querySelectorAll('input[placeholder*="Durchsuchen Sie"]').forEach(function(e){e.setAttribute('placeholder','Wonach suchst du?');});
    document.querySelectorAll('[aria-label*="Einkaufswagen"]').forEach(function(e){e.setAttribute('aria-label',e.getAttribute('aria-label').replace(/Einkaufswagen/g,'Warenkorb'));});}
  var q=false;new MutationObserver(function(){if(!q){q=true;requestAnimationFrame(function(){q=false;run();});}}).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();


/* Facefitness: Runder Pfeil sitzt in Pill-Buttons rechts mit gleichem Abstand wie oben/unten */
(function(){
  function fit(){
    var l=document.querySelectorAll('a > .ffx:last-child, button > .ffx:last-child, a > .ffx-in:last-child, button > .ffx-in:last-child');
    for(var i=0;i<l.length;i++){var x=l[i],h=x.parentElement;
      x.style.marginInlineEnd='';
      var hc=getComputedStyle(h),hr=h.getBoundingClientRect(),xr=x.getBoundingClientRect();
      if(!hr.height||!xr.height) continue;
      var pill=parseFloat(hc.borderTopLeftRadius)>=hr.height/2-2 && hr.height<90;
      var painted=(hc.backgroundColor!=='rgba(0, 0, 0, 0)'&&hc.backgroundColor!=='transparent')||hc.backgroundImage!=='none'||parseFloat(hc.borderRightWidth)>0;
      if(!pill||!painted) continue;
      if(Math.abs((xr.top+xr.bottom)/2-(hr.top+hr.bottom)/2)>4) continue; /* nur wenn Kreis in derselben Zeile mittig sitzt */
      var ideal=(hr.height-xr.height)/2, gap=hr.right-xr.right;
      if(Math.abs(gap-parseFloat(hc.paddingRight)-parseFloat(hc.borderRightWidth))>3) continue; /* nur wenn der Kreis am Inhaltsende anliegt */
      if(gap-ideal>1.5) x.style.marginInlineEnd=(-(gap-ideal))+'px';
    }
  }
  var t;function later(){clearTimeout(t);t=setTimeout(fit,120);}
  window.addEventListener('resize',later);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(later);
  window.addEventListener('load',later);
  new MutationObserver(later).observe(document.documentElement,{childList:true,subtree:true});
})();
